/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { addClass, getShadowElement, removeClass } from '@tylertech/forge-core';
import { BaseAdapter } from '../core/base/base-adapter';
import { BADGE_CONSTANTS } from './badge-constants';
export class BadgeAdapter extends BaseAdapter {
    constructor(component) {
        super(component);
        this._rootElement = getShadowElement(component, BADGE_CONSTANTS.selectors.ROOT);
    }
    setRootClass(classes) {
        addClass(classes, this._rootElement);
    }
    removeRootClass(classes) {
        removeClass(classes, this._rootElement);
    }
}
